module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'clients',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/secure/clients",
            /**************************************************
            * searchFor: potentialClientList
            * brokerNumber: 0000055085 --> agency ID
            * loginId: username
            ***************************************************/
            fetch: function() {
                return this.get();
            }
        });
    }]);
};
